<template>
  <div class="contact-wrapper">
    <!-- Hero Section -->
    <section class="hero-section py-12 mb-8">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="8" lg="6" class="text-center">
            <h1 class="text-h2 mb-6" style="color: #2ab3b8; font-weight: 500">Contact Us</h1>
            <p class="text-h5 mx-auto" style="color: #37474f; line-height: 1.6">
              Feel free to reach out to us with any questions or feedback. We are always happy to
              hear from you.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Contact Form Section -->
    <section class="contact-section">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="10" lg="8">
            <v-card class="contact-card" style="border: 2px solid rgba(42, 179, 184, 0.3)">
              <v-card-text class="pa-6">
                <v-text-field v-model="name" label="Name" outlined></v-text-field>
                <v-text-field v-model="email" label="Email Address" outlined></v-text-field>
                <v-text-field v-model="phone" label="Phone Number" outlined></v-text-field>
                <v-textarea v-model="message" label="Message" outlined></v-textarea>
                <v-btn color="#2ab3b8" @click="sendMessage" class="mt-4">
                  SEND <v-icon right size="24">mdi-send-circle</v-icon>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
import APIService from "@/services/APIService";

export default {
  name: "ContactView",
  data: () => ({
    name: "",
    email: "",
    phone: "",
    message: "",
  }),
  methods: {
    async sendMessage() {
      if (this.name === "" || this.email === "" || this.message === "") {
        alert("Please fill out all fields");
        return;
      }

      const to_send = `Name: ${this.name}\nEmail: ${this.email}\nPhone: ${this.phone}\nMessage: ${this.message}`;
      APIService.sns(`New Discussion: ${this.name}`, to_send).then((response) => {
        this.name = "";
        this.email = "";
        this.phone = "";
        this.message = "";
        console.log(response.data);
        this.$router.push({ name: "sent" });
      });
    },
  },
};
</script>

<style scoped>
.contact-wrapper {
  background: linear-gradient(to bottom, #ffffff, #f5f5f5);
  min-height: 100vh;
}

.hero-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.contact-card {
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 25px rgba(42, 179, 184, 0.1);
}

.contact-card:hover {
  transform: translateY(-4px);
}

@media (max-width: 960px) {
  .text-h2 {
    font-size: 2.5rem !important;
  }

  .text-h5 {
    font-size: 1.25rem !important;
  }
}
</style>
